import { getCurrentInstance } from 'vue'

export function useLog() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('useActLog必须在setup函数中调用')
  }
  return instance.appContext.config.globalProperties.$actlog
} 